// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"f0d4e877","379":"e84e51c1","498":"f7cdbc24","703":"602d88cb","706":"daee4798","787":"9495dde2","863":"7f8c36c6"}[chunkId] + ".chunk.js";
};